import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import Chip from "@mui/material/Chip";
import { alpha, type Theme } from "@mui/material/styles";

import { EndorsementStatus } from "@covertree/agent-portal-graphql";
import { Status } from "@covertree/ui/content/StatusLabel";

import { DISPLAY_LABELS, mapEndorsementStatusType } from "./types";

const PILL_BG: Record<Status, (theme: Theme) => object> = {
  active: (theme) => ({
    bgcolor: theme.palette.primary.light,
    color: theme.palette.primary.dark,
  }),
  expired: (theme) => ({
    bgcolor: alpha(theme.palette.error.main, 0.12),
    color: theme.palette.error.main,
  }),
  pending: (theme) => ({
    bgcolor: theme.palette.secondary.light,
    color: theme.palette.text.primary,
  }),
  initial: (theme) => ({
    bgcolor: theme.palette.action.disabledBackground,
    color: theme.palette.text.disabled,
  }),
};

interface EndorsementStatusPillProps {
  displayStatus: EndorsementStatus;
}

export function EndorsementStatusPill({
  displayStatus,
}: EndorsementStatusPillProps) {
  const statusType = mapEndorsementStatusType(displayStatus);
  const isIssued = displayStatus === EndorsementStatus.Issued;

  return (
    <Chip
      size="small"
      icon={<FiberManualRecordIcon />}
      label={DISPLAY_LABELS[displayStatus]}
      sx={(theme) => ({
        ...(isIssued
          ? {
              bgcolor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
            }
          : PILL_BG[statusType](theme)),
        height: 20,
        textTransform: "uppercase",
        fontWeight: 400,
        letterSpacing: 0.5,
        fontSize: "0.65rem",
        "& .MuiChip-label": { px: 0.75 },
        "& .MuiChip-icon": {
          fontSize: 7,
          color: "inherit",
          position: "relative",
          top: "-1px",
        },
      })}
    />
  );
}
